/* @ngInject */
function FetchReactDataFactory($window, $log) {
  var STORAGE_KEY = 'ANGULAR_TRANSITION_DATA';
  return {
    getTransitionData: getTransitionData,
    clearTransitionData: clearTransitionData,
    setTransitionData: setTransitionData
  };
  function getTransitionData() {
    var dataString = $window.sessionStorage.getItem(STORAGE_KEY);
    if (!dataString) {
      return null;
    }
    try {
      var payload = JSON.parse(dataString);
      return payload;
    } catch (e) {
      $log.error('Failed to parse transition data', e);
      return null;
    }
  }
  function clearTransitionData() {
    $window.sessionStorage.removeItem(STORAGE_KEY);
  }
  function setTransitionData(data) {
    $window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }
}

export default FetchReactDataFactory;



// WEBPACK FOOTER //
// ./client/app/common/fetch-react-data/fetch-react-data.factory.js